"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import { Printer } from "lucide-react";
import { PaymentIcon } from "~/components/icons/payment-eon";
import { FormattedTitle } from "~/components/job-page/ad/formatted-title-eon";
import JobAdVideo from "~/components/job-page/jobadvideo/jobad-video-eon";
import { Button } from "~/components/ui/button-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import ShareDropdownHungary from "./share-dropdown-eon-hungary";
export default function HeaderImageHungary(t0) {
  const $ = _c(49);
  const {
    job
  } = t0;
  const t = useLanguage();
  const isVideo = job.content.headerImage === "images/header/subclients/hungary/02General.webp";
  let t1;
  if ($[0] !== isVideo || $[1] !== job.content.headerImage) {
    t1 = <div className="relative aspect-video lg:aspect-auto">{isVideo ? <JobAdVideo className="h-full max-h-[700px]" hideControls={true} loop={true} muted={true} playOnLoad={true} videoUrl="hungary/headervideo2025.mp4" /> : <CustomImage className="h-full max-h-[700px] object-cover object-left" height={1070} sizes="(max-width: 1024px) 100vw, 60vw" src={job.content.headerImage} width={2000} />}</div>;
    $[0] = isVideo;
    $[1] = job.content.headerImage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== job.data.title) {
    t2 = <div className="text-lg xl:text-xl"><h1 className="mt-4 font-headline text-3xl xl:text-4xl"><FormattedTitle input={job.data.title} /></h1></div>;
    $[3] = job.data.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CustomImage alt="" className="mt-1 mr-3" height={34} src="images/icons/home.svg" width={34} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== job.data.company) {
    t4 = <li className="flex w-full items-center">{t3}<span>{job.data.company}</span></li>;
    $[6] = job.data.company;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CustomImage alt="" className="mt-1 mr-3" height={34} src="images/icons/file_white.svg" width={34} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== job.data.contract) {
    t6 = <li className="flex w-full items-center">{t5}<span>{job.data.contract}</span></li>;
    $[9] = job.data.contract;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CustomImage alt="" className="mt-1 mr-3" height={34} src="images/icons/clock.svg" width={34} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== job.data.employmentType || $[13] !== t) {
    t8 = combineEmploymentTypes(job.data.employmentType, t);
    $[12] = job.data.employmentType;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <li className="flex w-full items-center">{t7}<span>{t8}</span></li>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li className="flex w-full"><PaymentIcon className="mt-1 mr-3 size-[34px] shrink-0 text-white" /><p>A pozícióhoz tartozó bér és a részletes juttatási csomag az álláshirdetésben található.</p></li>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CustomImage alt="" className="mt-1 mr-3" height={34} src="images/icons/tag.svg" width={34} />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== job.data.idClient || $[20] !== t.jobad_details_jobNumber) {
    t12 = <li className="flex w-full items-center">{t11}<span>{t.jobad_details_jobNumber}: {job.data.idClient}</span></li>;
    $[19] = job.data.idClient;
    $[20] = t.jobad_details_jobNumber;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t4 || $[24] !== t6 || $[25] !== t9) {
    t13 = <ul className="flex flex-col text-lg md:mt-2 lg:mt-8 xl:text-xl">{t4}{t6}{t9}{t10}{t12}</ul>;
    $[22] = t12;
    $[23] = t4;
    $[24] = t6;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== job) {
    t14 = <ShareDropdownHungary job={job} />;
    $[27] = job;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Printer className="size-6" />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t.jobad_print) {
    t16 = <Button aria-label={t.jobad_print} className="flex h-full w-full items-center justify-center" onClick={_temp} variant="ghost">{t15}</Button>;
    $[30] = t.jobad_print;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== job.data) {
    t17 = toSimilarJob(job.data);
    $[32] = job.data;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17) {
    t18 = <WatchJobButton jobData={t17} variant="ghost" />;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== t18) {
    t19 = <section className="my-8 grid grid-flow-col grid-cols-3 gap-4">{t14}{t16}{t18}</section>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t13 || $[41] !== t19) {
    t20 = <div>{t13}{t19}</div>;
    $[40] = t13;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t2 || $[44] !== t20) {
    t21 = <div className="h-full px-6 py-2 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="flex h-full flex-col justify-between md:gap-6 xl:justify-end xl:gap-8">{t2}{t20}</div></div>;
    $[43] = t2;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t1 || $[47] !== t21) {
    t22 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-cols-fr lg:auto-cols-[2fr_1fr] lg:grid-flow-col xl:auto-cols-[3fr_2fr]">{t1}{t21}</div></section>;
    $[46] = t1;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  return t22;
}
function _temp() {
  return window.print();
}